import { render, staticRenderFns } from "./Styles.vue?vue&type=template&id=38b5e4a6&scoped=true&"
import script from "./Styles.vue?vue&type=script&lang=js&"
export * from "./Styles.vue?vue&type=script&lang=js&"
import style0 from "./Styles.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Styles.vue?vue&type=style&index=1&id=38b5e4a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b5e4a6",
  null
  
)

export default component.exports